// IE 2026 09 21 / ODOO-5800 (п. 1 «Недоделанного» передачи ie-dm7 → ie-bio7: «названия узла / правила / документа в строке пояснения и в блоке DETAILS — кликабельные»):
// ССЫЛКИ В ФОРМЕ ЯЧЕЙКИ. Бэк (reason_explain.py, cell_passport.py) отдаёт строку пояснения / паспорта как [подпись, значение, links?]: третий элемент — ссылки ЭТОЙ строки
//   {kind: 'rule' | 'node' | 'doc', id, segment, version?, collection?, title} — название каждой есть подстрока значения, ссылки идут по порядку появления.
// Значение режется по названиям: первое вхождение каждого названия ПОСЛЕ предыдущей ссылки (бэк отдаёт только ссылки, которые так находятся на своём месте; одно и то же
// название может повторяться — «planned SO» трёх разных документов).
// Открываемая ссылка — с id и сегментом записи (узел прежнего бэка нёс id субъекта без сегмента — не открывается); заглушки названий ('rule', 'this node') и названия короче
// двух знаков ссылкой не становятся. Выключатель формы — fe.ux.cellExplainLinks (читает Dropdown.vue).
import { t } from '@/i18n'   // IE 2026 09 23 / ODOO-341407: i18n
const STUB_TITLES = new Set(['rule', 'this node'])

export const CELL_LINK_HINTS = { get rule() { return t('Open the rule') }, get node() { return t('Open the calculation node') }, get doc() { return t('Open the document') }, get widget() { return t('Open the register list') } }   // IE 2026 10 13 / ODOO-5800: + widget   // IE 2026 09 23 / ODOO-341407: i18n — геттеры: t() при чтении

// ссылку можно открыть без догадок: id + сегмент записи; название — не заглушка
export function cellLink_ok(l) {
    if (!l || typeof l !== 'object' || !l.id || !l.segment) return false
    const t = String(l.title ?? '').trim()
    return t.length >= 2 && !STUB_TITLES.has(t)
}

// подсказка ссылки по её виду
export function cellLink_hint(l) {
    return CELL_LINK_HINTS[l?.kind] || t('Open the record')   // IE 2026 09 23 / ODOO-341407: i18n
}

// значение → куски [{ t: текст, link: ссылка | null }]; без ссылок — один кусок с исходным текстом (склейка кусков всегда даёт исходное значение)
export function cellLink_parts(value, links) {
    const s = String(value ?? '')
    const out = []
    let cur = 0
    for (const l of Array.isArray(links) ? links : []) {
        if (!cellLink_ok(l)) continue
        const t = String(l.title)
        const i = s.indexOf(t, cur)
        if (i < 0) continue
        if (i > cur) out.push({ t: s.slice(cur, i), link: null })
        out.push({ t, link: l })
        cur = i + t.length
    }
    if (cur < s.length || !out.length) out.push({ t: s.slice(cur), link: null })
    return out
}

// общий список ссылок пояснения идёт по порядку всего пояснения, а не этого текста — раскладываем по месту первого вхождения названия
function byPlace(text, links) {
    const s = String(text ?? '')
    return (Array.isArray(links) ? links : []).filter(cellLink_ok).map(l => [s.indexOf(String(l.title)), l]).filter(x => x[0] >= 0).sort((a, b) => a[0] - b[0]).map(x => x[1])
}

// строка пояснения под метрикой: свои ссылки (третий элемент строки); данные прежнего бэка (ни у одной строки пояснения своих ссылок нет) — общий список links пояснения
export function cellLink_noteRowParts(row, note) {
    const value = row?.[1]
    if (Array.isArray(row?.[2])) return cellLink_parts(value, row[2])
    const rows = Array.isArray(note?.rows) ? note.rows : []
    if (rows.some(r => Array.isArray(r?.[2]))) return cellLink_parts(value, [])
    return cellLink_parts(value, byPlace(value, note?.links))
}

// вывод пояснения (первая строка): своих ссылок у него нет — общий список пояснения
export function cellLink_noteTextParts(note) {
    return cellLink_parts(note?.text, byPlace(note?.text, note?.links))
}
